export default {
  bind(el, binding, vnode, oldVnode) {
    const h = binding.arg
    const dragDom = binding.value.$el.querySelector('.el-dialog')
    el.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - el.offsetLeft
      const disY = e.clientY - el.offsetTop
      document.onmousemove = function(e) {
        e.preventDefault() // 移动时禁用默认事件
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY
        dragDom.style.width = `${l}px`
        if (h !== 'false') {
          dragDom.style.height = `${t}px`
        }
      }

      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
        const data = {
          width: dragDom.style.width,
          height: dragDom.style.height
        }
        vnode.data.on.changeDone.apply(vnode.context, [data])
      }
    }
  }
}
